import MapIcon from '../assets/svg/map.svg';
import RequestLocationIcon from '../assets/svg/request_location.svg';
import ProfileIcon from '../assets/svg/profile.svg';
import CarIcon from '../assets/svg/car.svg';

type RouteType = {
  id: string;
  name: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
};

export const routes: RouteType[] = [
  {
    id: 'map',
    name: 'Map',
    href: '/',
    icon: MapIcon,
  },
  {
    id: 'profile',
    name: 'Profile',
    href: '/profile',
    icon: ProfileIcon,
  },
];

export const zenRoutes: RouteType[] = [
  {
    id: 'map',
    name: 'Map',
    href: '/',
    icon: MapIcon,
  },
  {
    id: 'car',
    name: 'Car',
    href: '/zen',
    icon: CarIcon,
  },
  {
    id: 'profile',
    name: 'Profile',
    href: '/profile',
    icon: ProfileIcon,
  },
];

export type BottomRouteType = {
  name: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
};
